export const config = {
  getRecommendationServiceUrl(baseUrl) {
    return baseUrl ? `${baseUrl}/gateway/api/v1/recommendations` : '/gateway/api/v1/recommendations';
  },
  getUsersServiceUrl(productKey, baseUrl = '') {
    return productKey === 'jira' ? `${baseUrl}/rest/api/3/user/bulk` : `${baseUrl}/wiki/rest/api/user/bulk`;
  },
  getGraphQLUrl(baseUrl) {
    return baseUrl ? `${baseUrl}/gateway/api/graphql` : `/gateway/api/graphql`;
  },
  getTeamsUrl(baseUrl) {
    return baseUrl ? `${baseUrl}/gateway/api/v3/teams` : `/gateway/api/v3/teams`;
  }
};